<template>
  <div>
    <!-- 创建分组弹框 -->
    <Dialogs :dialogs="dialogCreat" @dialogVisible="beforeClose">
      <template #desc>
        <div class="drawer_content">
          <div class="info_conts">
            <div class="info_subject">
              <el-input
                type="textarea"
                placeholder="请输入任务名称，200字以内"
                v-model="dialogCreat.taskname"
                :autosize="{ minRows: 1, maxRows: 5 }"
                maxlength="200"
                show-word-limit
              />
            </div>
            <!-- 任务编号 -->
            <div class="info">
              <div class="info_key">
                <div style="color: #ff4d42; margin-right: 3px">*</div>
                <i
                  class="iconfont icon-jinghao info_icon"
                  style="font-size: 15px"
                />
                <el-tooltip
                  effect="dark"
                  content="任务编号"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>任务编号</div>
                </el-tooltip>
              </div>
              <div class="info_value">
                <el-input
                  ref="input_name"
                  :autofocus="true"
                  v-model="dialogCreat.taskNumber"
                  placeholder="点击添加"
                />
              </div>
            </div>
            <!-- 所属项目 -->
            <div class="info" v-if="dialogCreat.title == '创建任务' && !proId">
              <div class="info_key">
                <div style="width:11px" />
                <i
                  class="iconfont icon-xiangmu info_icon"
                  style="font-size: 12px"
                />
                <el-tooltip
                  effect="dark"
                  content="所属项目"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>所属项目</div>
                </el-tooltip>
              </div>
              <div class="info_value">
                <el-select
                  v-model="dialogCreat.proId"
                  filterable
                  placeholder="请选择所属项目"
                  @change="describes.proId = dialogCreat.proId"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in proType"
                    :key="item.id"
                    :label="item.proname"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <!-- 任务类型 -->
            <div class="info">
              <div class="info_key">
                <div style="width:11px" />
                <i
                  class="iconfont icon-type info_icon"
                  style="font-size: 13px"
                />
                <el-tooltip
                  effect="dark"
                  content="任务类型"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>任务类型</div>
                </el-tooltip>
              </div>
              <div class="info_value">
                <el-select
                  v-model="dialogCreat.taskType"
                  placeholder="请选择任务类型"
                  @blur="getChoiceList"
                  style="width:100%"
                >
                  <el-option label="标准任务" value="0" />
                  <el-option label="流程任务" value="1" />
                </el-select>
              </div>
            </div>
            <!-- 工作流程 -->
            <div class="info" v-if="dialogCreat.taskType == '1'">
              <div class="info_key">
                <div style="color: #ff4d42; margin-right: 3px">*</div>
                <i
                  class="iconfont icon-task info_icon"
                  style="font-size: 12px"
                />
                <el-tooltip
                  effect="dark"
                  content="工作流程"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>工作流程</div>
                </el-tooltip>
              </div>
              <div class="info_value">
                <el-select
                  v-model="dialogCreat.flowId"
                  filterable
                  placeholder="请选择流程类型"
                  style="width:100%"
                  @change="processDeta"
                  :open-delay="500"
                >
                  <el-option
                    v-for="item in options"
                    :key="item.id"
                    :label="item.flowName"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <!-- 表单类型 -->
            <div class="info">
              <div class="info_key">
                <div style="width:11px" />
                <i
                  class="iconfont icon-type info_icon"
                  style="font-size: 13px"
                />
                <el-tooltip
                  effect="dark"
                  content="表单类型"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>表单类型</div>
                </el-tooltip>
              </div>
              <div class="info_value">
                <el-select
                  v-model="dialogCreat.formId"
                  filterable
                  placeholder="请选择表单类型"
                  @change="formDetail"
                  style="width:100%"
                >
                  <el-option
                    v-for="item in formList"
                    :key="item.id"
                    :label="item.formName"
                    :value="item.id"
                  />
                </el-select>
              </div>
            </div>
            <!-- 负责人 -->
            <div class="info" v-if="dialogCreat.taskType == '0'">
              <div class="info_key">
                <div style="width:11px" />
                <i class="iconfont icon-fuzeren info_icon" />
                <el-tooltip
                  effect="dark"
                  content="负责人"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>负责人</div>
                </el-tooltip>
              </div>
              <div
                class="info_value"
                v-if="dialogCreat.responseUsers.length > 0"
              >
                <div
                  class="personnel"
                  style="width: 83%; display: flex; align-items: flex-start"
                >
                  <draggable
                    v-model="dialogCreat.responseUsers"
                    group="responseUsers"
                    :options="{ handle: '.info_personnel1' }"
                    style="width: calc(100% - 70px)"
                    animation="500"
                  >
                    <transition-group style="display: flex; flex-wrap: wrap">
                      <div
                        class="user_personnel"
                        v-for="(item, index2) in dialogCreat.responseUsers"
                        :key="index2"
                        @click="contactCh(dialogCreat.responseUsers, 1)"
                      >
                        <div class="info_personnel1" v-if="channel === 'ding'">
                          <img
                            v-if="item.avatar != ''&& item.avatar != null"
                            class="info_personnel_surname1"
                            :src="item.avatar"
                          >
                          <div v-else class="info_personnel_surname1">
                            {{item.name.substring(0, 1)}}
                          </div>
                          <div>{{item.name}}</div>
                        </div>
                        <div class="info_personnel1" v-if="channel === 'wechat'">
                          <img
                            v-if="item.avatar != ''&& item.avatar != null"
                            class="info_personnel_surname1"
                            :src="item.avatar"
                          >
                          <!-- <div v-else class="info_personnel_surname1">
                            {{item.name.substring(0, 1)}}
                          </div> -->
                          <div>
                            <ww-open-data type="userName" :openid="item.name" />
                          </div>
                        </div>
                        <i
                          class="iconfont icon-shanchu del_icon"
                          @click.stop="
                            delUsers(dialogCreat.responseUsers, index2, 1)
                          "
                        />
                      </div>
                    </transition-group>
                  </draggable>
                  <el-popover
                    placement="bottom-start"
                    width="440"
                    trigger="click"
                    v-model="responseUsers_popover"
                  >
                    <div class="select_type">
                      <span>确认方式选择 </span>
                      <el-tooltip
                        effect="dark"
                        popper-class="texttooltip"
                        placement="right"
                        :open-delay="500"
                      >
                        <div slot="content">
                          顺签：指定人依次完成<br>或签：某一指定人完成
                          <br>会签：所有指定人完成
                        </div>
                        <i class="iconfont icon-shuoming progress_icon" />
                      </el-tooltip>
                      <div class="select_type_radio">
                        <el-radio-group v-model="dialogCreat.responseType">
                          <el-radio label="0">顺签</el-radio>
                          <el-radio label="1">或签</el-radio>
                          <el-radio label="2">会签</el-radio>
                        </el-radio-group>
                      </div>
                      <div class="select__type_personnel">
                        <div>负责人选择</div>
                        <div
                          class="select__type_personnel_clear"
                          @click.stop="dialogCreat.responseUsers = []"
                        >
                          清空
                        </div>
                      </div>
                      <div class="users_personnel1">
                        <draggable
                          v-model="dialogCreat.responseUsers"
                          group="responseUsers1"
                          :options="{ handle: '.info_personnel1' }"
                          animation="500"
                        >
                          <transition-group
                            style="display: flex; flex-wrap: wrap"
                          >
                            <div
                              class="user_personnel"
                              v-for="(
                                item, index2
                              ) in dialogCreat.responseUsers"
                              :key="index2"
                            >
                              <div class="info_personnel1" v-if="channel === 'ding'">
                                <img
                                  v-if="item.avatar != ''&& item.avatar != null"
                                  class="info_personnel_surname1"
                                  :src="item.avatar"
                                >
                                <div v-else class="info_personnel_surname1">
                                  {{item.name.substring(0, 1)}}
                                </div>
                                <div>{{item.name}}</div>
                              </div>
                              <div class="info_personnel1" v-if="channel === 'wechat'">
                                <img
                                  v-if="item.avatar != ''&& item.avatar != null"
                                  class="info_personnel_surname1"
                                  :src="item.avatar"
                                >
                                <!-- <div v-else class="info_personnel_surname1">
                                  {{item.name.substring(0, 1)}}
                                </div> -->
                                <div>
                                  <ww-open-data type="userName" :openid="item.name" />
                                </div>
                              </div>
                              <i
                                class="iconfont icon-shanchu del_icon"
                                @click.stop="
                                  delUsers(dialogCreat.responseUsers, index2, 1)
                                "
                              />
                            </div>
                          </transition-group>
                        </draggable>
                        <i
                          class="iconfont icon-jiahao2fill add_icon"
                          :style="
                            dialogCreat.responseUsers &&
                              dialogCreat.responseUsers.length > 0
                              ? 'margin-left:34px'
                              : ''
                          "
                          @click.stop="contactCh(dialogCreat.responseUsers, 1)"
                        />
                      </div>
                    </div>
                    <div slot="reference">
                      <div
                        @click.stop="responseUsers_popover = true"
                        v-show="dialogCreat.responseUsers.length > 1"
                        style="width: 70px"
                      >
                        <div
                          v-show="dialogCreat.responseType == 0"
                          class="info_personnel"
                        >
                          <i class="iconfont icon-shuzishunxu info_icon" />
                          <div>顺签</div>
                        </div>
                        <div
                          v-show="dialogCreat.responseType == 1"
                          class="info_personnel"
                        >
                          <i
                            class="
                              iconfont
                              icon-feijiaoxuedanweikaohebiaozhungonggongshiwubufen-kaohe
                              info_icon
                            "
                          />
                          <div>或签</div>
                        </div>
                        <div
                          v-show="dialogCreat.responseType == 2"
                          class="info_personnel"
                        >
                          <i class="iconfont icon-KJ_012 info_icon" />
                          <div>会签</div>
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </div>
                <div
                  class="type"
                  style="width: 15%; text-align: right; margin-right: 15px"
                >
                  <div
                    class="type_text"
                    style="cursor: pointer"
                    @click="contactCh(dialogCreat.responseUsers, 1)"
                  >
                    选择人员
                  </div>
                </div>
              </div>
              <div class="info_value" v-else>
                <div
                  class="add_text"
                  @click="contactCh(dialogCreat.responseUsers, 1)"
                >
                  点击添加
                </div>
              </div>
            </div>
            <!-- 确认人 -->
            <div class="info" v-if="dialogCreat.taskType == '0'">
              <div class="info_key">
                <div style="width:11px" />
                <i class="iconfont icon-querenren info_icon" />
                <el-tooltip
                  effect="dark"
                  content="确认人"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>确认人</div>
                </el-tooltip>
              </div>
              <div
                class="info_value"
                v-if="dialogCreat.confirmUsers.length > 0"
              >
                <div
                  class="personnel"
                  style="width: 83%; display: flex; align-items: flex-start"
                >
                  <draggable
                    v-model="dialogCreat.confirmUsers"
                    group="confirmUsers"
                    :options="{ handle: '.info_personnel1' }"
                    style="width: calc(100% - 70px)"
                    animation="500"
                  >
                    <transition-group style="display: flex; flex-wrap: wrap">
                      <div
                        class="user_personnel"
                        v-for="(item, index2) in dialogCreat.confirmUsers"
                        :key="index2"
                        @click="contactCh(dialogCreat.confirmUsers, 2)"
                      >
                        <div class="info_personnel1" v-if="channel === 'ding'">
                          <img
                            v-if="item.avatar != ''&& item.avatar != null"
                            class="info_personnel_surname1"
                            :src="item.avatar"
                          >
                          <div v-else class="info_personnel_surname1">
                            {{item.name.substring(0, 1)}}
                          </div>
                          <div>{{item.name}}</div>
                        </div>
                        <div class="info_personnel1" v-if="channel === 'wechat'">
                          <img
                            v-if="item.avatar != ''&& item.avatar != null"
                            class="info_personnel_surname1"
                            :src="item.avatar"
                          >
                          <!-- <div v-else class="info_personnel_surname1">
                            {{item.name.substring(0, 1)}}
                          </div> -->
                          <div>
                            <ww-open-data type="userName" :openid="item.name" />
                          </div>
                        </div>
                        <i
                          class="iconfont icon-shanchu del_icon"
                          @click.stop="
                            delUsers(dialogCreat.confirmUsers, index2, 2)
                          "
                        />
                      </div>
                    </transition-group>
                  </draggable>
                  <el-popover
                    placement="bottom-start"
                    width="440"
                    trigger="click"
                    v-model="confirmUsers_popover"
                  >
                    <div class="select_type">
                      <span>确认方式选择 </span>
                      <el-tooltip
                        effect="dark"
                        popper-class="texttooltip"
                        placement="right"
                        :open-delay="500"
                      >
                        <div slot="content">
                          顺签：指定人依次完成<br>或签：某一指定人完成
                          <br>会签：所有指定人完成
                        </div>
                        <i class="iconfont icon-shuoming progress_icon" />
                      </el-tooltip>
                      <div class="select_type_radio">
                        <el-radio-group v-model="dialogCreat.confirmType">
                          <el-radio label="0">顺签</el-radio>
                          <el-radio label="1">或签</el-radio>
                          <el-radio label="2">会签</el-radio>
                        </el-radio-group>
                      </div>
                      <div class="select__type_personnel">
                        <div>确认人选择</div>
                        <div
                          class="select__type_personnel_clear"
                          @click.stop="dialogCreat.confirmUsers = []"
                        >
                          清空
                        </div>
                      </div>
                      <div class="users_personnel1">
                        <draggable
                          v-model="dialogCreat.confirmUsers"
                          group="confirmUsers1"
                          :options="{ handle: '.info_personnel1' }"
                          animation="500"
                        >
                          <transition-group
                            style="display: flex; flex-wrap: wrap"
                          >
                            <div
                              class="user_personnel1"
                              v-for="(item, index2) in dialogCreat.confirmUsers"
                              :key="index2"
                            >
                              <div
                                class="info_personnel1"
                                @click.stop="
                                  contactCh(dialogCreat.confirmUsers, 2)
                                "
                                v-if="channel === 'ding'"
                              >
                                <img
                                  v-if="item.avatar != ''&& item.avatar != null"
                                  class="info_personnel_surname1"
                                  :src="item.avatar"
                                >
                                <div v-else class="info_personnel_surname1">
                                  {{item.name.substring(0, 1)}}
                                </div>
                                <div>{{item.name}}</div>
                              </div>
                              <div
                                class="info_personnel1"
                                @click.stop="
                                  contactCh(dialogCreat.confirmUsers, 2)
                                "
                                v-if="channel === 'wechat'"
                              >
                                <img
                                  v-if="item.avatar != ''&& item.avatar != null"
                                  class="info_personnel_surname1"
                                  :src="item.avatar"
                                >
                                <!-- <div v-else class="info_personnel_surname1">
                                  {{item.name.substring(0, 1)}}
                                </div> -->
                                <div>
                                  <ww-open-data type="userName" :openid="item.name" />
                                </div>
                              </div>
                              <i
                                class="iconfont icon-shanchu del_icon"
                                @click.stop="
                                  delUsers(dialogCreat.confirmUsers, index2, 2)
                                "
                              />
                            </div>
                          </transition-group>
                        </draggable>
                        <i
                          class="iconfont icon-jiahao2fill add_icon"
                          :style="
                            dialogCreat.confirmUsers &&
                              dialogCreat.confirmUsers.length > 0
                              ? 'margin-left:34px'
                              : ''
                          "
                          @click.stop="contactCh(dialogCreat.confirmUsers, 2)"
                        />
                      </div>
                    </div>
                    <div slot="reference">
                      <div
                        @click.stop="confirmUsers_popover = true"
                        v-show="dialogCreat.confirmUsers.length > 1"
                      >
                        <div
                          v-show="dialogCreat.confirmType == 0"
                          class="info_personnel"
                        >
                          <i class="iconfont icon-shuzishunxu info_icon" />
                          <div>顺签</div>
                        </div>
                        <div
                          v-show="dialogCreat.confirmType == 1"
                          class="info_personnel"
                        >
                          <i
                            class="
                              iconfont
                              icon-feijiaoxuedanweikaohebiaozhungonggongshiwubufen-kaohe
                              info_icon
                            "
                          />
                          <div>或签</div>
                        </div>
                        <div
                          v-show="dialogCreat.confirmType == 2"
                          class="info_personnel"
                        >
                          <i class="iconfont icon-KJ_012 info_icon" />
                          <div>会签</div>
                        </div>
                      </div>
                    </div>
                  </el-popover>
                </div>
                <div
                  class="type"
                  style="width: 15%; text-align: right; margin-right: 15px"
                >
                  <div
                    class="type_text"
                    style="cursor: pointer"
                    @click="contactCh(dialogCreat.confirmUsers, 2)"
                  >
                    选择人员
                  </div>
                </div>
              </div>
              <div class="info_value" v-else>
                <div
                  class="add_text"
                  @click="contactCh(dialogCreat.confirmUsers, 2)"
                >
                  点击添加
                </div>
              </div>
            </div>

            <!-- 计划开始 -->
            <div class="info">
              <div class="info_key">
                <div style="width:11px" />
                <i
                  class="iconfont icon-riqi info_icon"
                  style="font-size: 17px"
                />
                <el-tooltip
                  effect="dark"
                  content="计划开始"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>计划开始</div>
                </el-tooltip>
              </div>
              <div class="info_value">
                <!-- default-time="dialogCreat.defaultime.startTime" -->
                <div>
                  <div class="block">
                    <el-date-picker
                      style="width: 170px"
                      v-model="dialogCreat.planStartDate"
                      type="datetime"
                      value-format="yyyy/MM/dd HH:mm:ss"
                      format="yyyy/MM/dd HH:mm:ss"
                      placeholder="选择日期时间"
                      @focus="focusStartChange"
                      @blur="blurChange"
                      :picker-options="pickerOptions"
                      :default-time="dialogCreat.defaultime.startTime"
                    />
                  </div>
                </div>
                <div>
                  <!-- :default-time="dialogCreat.defaultime.endTime" -->
                  <el-tooltip
                    effect="dark"
                    content="计划截止"
                    placement="bottom"
                    popper-class="texttooltip"
                    :open-delay="500"
                  >
                    <span
                      class="date_label"
                      style="margin: 0 10px 0 5px"
                    >计划截止</span>
                  </el-tooltip>
                  <div style="display: inline-block">
                    <div class="block">
                      <el-date-picker
                        style="width: 170px"
                        v-model="dialogCreat.planEndDate"
                        type="datetime"
                        value-format="yyyy/MM/dd HH:mm:ss"
                        format="yyyy/MM/dd HH:mm:ss"
                        placeholder="选择日期时间"
                        @focus="focusEndChange"
                        @blur="blurChange"
                        :picker-options="pickerOptions1"
                        :default-time="dialogCreat.defaultime.endTime"
                      />
                    </div>
                  </div>
                </div>
                <!-- class="info_value_text" -->
                <div>
                  <span>
                    <el-dropdown
                      trigger="click"
                      :hide-on-click="false"
                      @command="selectWorkType"
                    >
                      <span
                        class="date_label"
                      >工期
                        <span v-if="dialogCreat.workTimeType === '0'">(自然日)</span>
                        <span v-if="dialogCreat.workTimeType === '1'">(工作日)</span>
                      </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="0">自然日</el-dropdown-item>
                        <el-dropdown-item command="1">工作日</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                    <span>
                      <el-input
                        v-model="dialogCreat.planWorkTime"
                        style="
                          margin: 0 5px 0 -20px;
                          padding: 0;
                          height: 36px;
                          width: 55px;
                        "
                        class="time_input"
                      />
                      <span>天</span>
                    </span>
                  </span>
                </div>
              </div>
            </div>
            <!-- 流程角色 -->
            <div class="info" v-show="dialogCreat.taskType == '1'" v-for="(item, index) in roleList" :key="index">
              <div class="info_key">
                <div style="color: #ff4d42; margin-right: 3px" v-show="item.mustFlag === '1'">*</div>
                <div style="width:9px" v-show="item.mustFlag !== '1'" />
                <i
                  class="iconfont icon-renqun info_icon"
                  style="font-size: 12px"
                />
                <el-tooltip
                  effect="dark"
                  :content="item.roleName"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div class="rolename">{{item.roleName}}</div>
                </el-tooltip>
              </div>
              <div
                class="info_value"
                v-if="item.userList.length > 0"
              >
                <div class="personnel" style="width:100%;display: flex;align-items: flex-start;">
                  <draggable
                    v-model="item.userList"
                    group="item.userList"
                    :options="{ handle: '.info_personnel1' }"
                    animation="500"
                  >
                    <transition-group style="display: flex; flex-wrap: wrap">
                      <div
                        class="info_value_text"
                        v-for="(itemF, index2) in item.userList"
                        :key="index2"
                        @click="contactCh(item.userList, item.id)"
                        style="display: flex;align-items: center;flex-wrap: wrap;"
                      >
                        <div
                          class="user_personnel"
                        >
                          <div class="info_personnel1" v-if="channel === 'ding'">
                            <img
                              v-if="itemF.avatar != ''&& itemF.avatar != null"
                              class="info_personnel_surname1"
                              :src="itemF.avatar"
                            >
                            <div v-else class="info_personnel_surname1">
                              {{itemF.name.substring(0, 1)}}
                            </div>
                            <div>{{itemF.name}}</div>
                          </div>
                          <div class="info_personnel1" v-if="channel === 'wechat'">
                            <img
                              v-if="itemF.avatar != ''&& itemF.avatar != null"
                              class="info_personnel_surname1"
                              :src="itemF.avatar"
                            >
                            <!-- <div v-else class="info_personnel_surname1">
                              {{itemF.name.substring(0, 1)}}
                            </div> -->
                            <div><ww-open-data type="userName" :openid="itemF.name" /></div>
                          </div>
                          <i
                            class="iconfont icon-shanchu del_icon"
                            @click.stop="
                              delUsers(item.userList, index2, item.id)
                            "
                          />
                        </div>
                        <i
                          v-show="item.userList.length - 1 == index2"
                          class="iconfont icon-jiahao2fill add_icon"
                          @click.stop="contactCh(item.userList, item.id)"
                          style="margin: 0 24px"
                        />
                      </div>
                    </transition-group>
                  </draggable>
                  <!-- <i
                      class="iconfont icon-jiahao2fill add_icon"
                      @click.stop="contactCh(item.userList, item.id)"
                      style="margin: 0 24px"
                    /> -->
                </div>
              </div>
              <div class="info_value" v-else>
                <div
                  class="add_text"
                  @click="contactCh(item.userList, item.id)"
                >
                  点击添加
                </div>
              </div>
            </div>
            <!-- 预计完成日期 v-if="dialogCreat.taskType == '1'&& corpId === 'ding379884b8b194a55f35c2f4657eb6378f'"-->
            <div class="info" v-if="dialogCreat.taskType == '1'&& corpId === 'ding379884b8b194a55f35c2f4657eb6378f'">
              <div class="info_key">
                <div style="width:11px" />
                <i class="iconfont icon-riqi info_icon" style="font-size: 17px" />
                <el-tooltip
                  effect="dark"
                  content="预计完成"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div class="form_fieldName">预计完成</div>
                </el-tooltip>
              </div>
              <div class="info_value">
                <div style="width: 100%">
                  <div class="block">
                    <el-date-picker
                      style="width: 100%"
                      v-model="dialogCreat.prodPlanEndDate"
                      type="datetime"
                      value-format="yyyy/MM/dd HH:mm:ss"
                      format="yyyy/MM/dd"
                      placeholder="选择预计完成日期"
                      @focus="focusStartChange"
                      @blur="blurChange"
                      :picker-options="pickerOptions"
                      default-time="00:00:00"
                    />
                  </div>
                </div>
              </div>
            </div>
            <!-- 表单 -->
            <Form
              :form-json="formJson"
              :pro-id="dialogCreat.proId"
              :formdetail="formDetailValue"
              :creat-type="''"
              v-if="dialogCreat.formId && dialogCreat.formId!='0'"
              @addForm="addForm"
            />
            <!-- 描述 -->
            <div class="info" v-if="dialogCreat.formId == '' || dialogCreat.formId=='0'">
              <div class="info_key">
                <div style="width:11px" />
                <i
                  class="iconfont icon-describe info_icon"
                  style="font-size: 14px"
                />
                <el-tooltip
                  effect="dark"
                  content="描述"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>描述</div>
                </el-tooltip>
              </div>
              <div style="width: 85%; margin-top: 5px">
                <Describe :describes="describes" @func="addtask" />
              </div>
            </div>
            <!-- 关注人 -->
            <div class="info" v-if="dialogCreat.flowId">
              <div class="info_key">
                <div style="width:11px" />
                <i
                  class="iconfont icon-renqun info_icon"
                  style="font-size: 12px"
                />
                <el-tooltip
                  effect="dark"
                  content="关注人"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>关注人</div>
                </el-tooltip>
              </div>
              <div
                class="info_value"
                v-if="formDetailValue.followUsers &&formDetailValue.followUsers.length > 0"
              >
                <div class="info_followUsers" style="margin: 0">
                  <draggable
                    v-model="formDetailValue.followUsers"
                    group="followUserList"
                    :options="{ handle: '.info_personnel1' }"
                    animation="500"
                  >
                    <transition-group style="display: flex; flex-wrap: wrap">
                      <div
                        class="info_personnel_followUsers"
                        v-for="(item, index2) in formDetailValue.followUsers"
                        :key="index2"
                        @click="contactCh(formDetailValue.followUsers, 3)"
                      >
                        <div class="info_personnel1" style="padding: 0" v-if="channel === 'ding'&& item.userType === '1'">
                          <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                            <img
                              v-if="item.avatar != ''&& item.avatar != null"
                              class="info_personnel_surname1"
                              :src="item.avatar"
                            >
                            <div class="info_personnel_surname1" v-else>
                              {{item.name.substring(0, 1)}}
                            </div>
                          </el-tooltip>
                        </div>
                        <div class="info_personnel1" style="padding: 0" v-if="channel === 'wechat'&& item.userType === '1'">
                          <img
                            v-if="item.avatar != ''&& item.avatar != null"
                            class="info_personnel_surname1"
                            :src="item.avatar"
                          >
                          <!-- <div v-else class="info_personnel_surname1">
                            {{item.name.substring(0, 1)}}
                          </div> -->
                        </div>
                        <i
                          class="iconfont icon-shanchu del_icon"
                          @click.stop="
                            delUsers(formDetailValue.followUsers, index2, 3)
                          "
                        />
                      </div>
                    </transition-group>
                  </draggable>
                  <i
                    class="iconfont icon-jiahao2fill add_icon"
                    @click.stop="contactCh(formDetailValue.followUsers, 3)"
                    style="margin: 0 24px"
                  />
                </div>
              </div>
              <div class="info_value" v-else>
                <div
                  class="add_text"
                  @click="contactCh(formDetailValue.followUsers, 3)"
                >
                  点击添加
                </div>
              </div>
            </div>
            <div class="info" v-else>
              <div class="info_key">
                <div style="width:11px" />
                <i
                  class="iconfont icon-renqun info_icon"
                  style="font-size: 12px"
                />
                <el-tooltip
                  effect="dark"
                  content="关注人"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>关注人</div>
                </el-tooltip>
              </div>
              <div
                class="info_value"
                v-if="dialogCreat.followUserList.length > 0"
              >
                <div class="info_followUsers" style="margin: 0">
                  <draggable
                    v-model="dialogCreat.followUserList"
                    group="followUserList"
                    :options="{ handle: '.info_personnel1' }"
                    animation="500"
                  >
                    <transition-group style="display: flex; flex-wrap: wrap">
                      <div
                        class="info_personnel_followUsers"
                        v-for="(item, index2) in dialogCreat.followUserList"
                        :key="index2"
                        @click="contactCh(dialogCreat.followUserList, 3)"
                      >
                        <div class="info_personnel1" style="padding: 0" v-if="channel === 'ding'">
                          <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom" :open-delay="500">
                            <img
                              v-if="item.avatar != ''&& item.avatar != null"
                              class="info_personnel_surname1"
                              :src="item.avatar"
                            >
                            <div class="info_personnel_surname1" v-else>
                              {{item.name.substring(0, 1)}}
                            </div>
                          </el-tooltip>
                        </div>
                        <div class="info_personnel1" style="padding: 0" v-if="channel === 'wechat'">
                          <img
                            v-if="item.avatar != ''&& item.avatar != null"
                            class="info_personnel_surname1"
                            :src="item.avatar"
                          >
                          <!-- <div v-else class="info_personnel_surname1">
                            {{item.name.substring(0, 1)}}
                          </div> -->
                        </div>
                        <i
                          class="iconfont icon-shanchu del_icon"
                          @click.stop="
                            delUsers(dialogCreat.followUserList, index2, 3)
                          "
                        />
                      </div>
                    </transition-group>
                  </draggable>
                  <i
                    class="iconfont icon-jiahao2fill add_icon"
                    @click.stop="contactCh(dialogCreat.followUserList, 3)"
                    style="margin: 0 24px"
                  />
                </div>
              </div>
              <div class="info_value" v-else>
                <div
                  class="add_text"
                  @click="contactCh(dialogCreat.followUserList, 3)"
                >
                  点击添加
                </div>
              </div>
            </div>

            <!-- 标签 -->
            <div
              class="info"
              v-if="dialogCreat.formId == '' || dialogCreat.formId=='0'"
              style="margin-bottom: 20px"
            >
              <div class="info_key">
                <div style="width:11px" />
                <i class="iconfont icon-tag info_icon" />
                <el-tooltip
                  effect="dark"
                  content="标签"
                  placement="bottom"
                  popper-class="texttooltip"
                  :open-delay="500"
                >
                  <div>标签</div>
                </el-tooltip>
              </div>
              <div class="info_value">
                <div class="info_box">
                  <div
                    class="info_tags"
                    v-for="(tag, index1) in dialogCreat.labelList"
                    :key="index1"
                    v-show="
                      dialogCreat.labelList && dialogCreat.labelList.length > 0
                    "
                  >
                    <el-tag
                      style="margin-right: 16px"
                      :style="
                        'color:' +
                          tag.color +
                          ';background:' +
                          convertHex(tag.color, 10)
                      "
                      type="warning"
                    >{{tag.labelName}}</el-tag>
                    <i
                      class="iconfont icon-shanchu del_icon"
                      @click="delTagsChange(tag)"
                    />
                  </div>
                  <el-popover placement="bottom" width="540" trigger="click">
                    <TagsList :tags-objects="tagsObject" :tag-lists="tagList" />
                    <i
                      class="iconfont icon-jiahao2fill add_icon"
                      slot="reference"
                      :style="
                        dialogCreat.labelList &&
                          dialogCreat.labelList.length > 0
                          ? 'margin: 0 10px;'
                          : 'margin: 0'
                      "
                    />
                  </el-popover>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Dialogs>
  </div>
</template>
<script>
import Dialogs from './dialog.vue'
import Describe from './describe.vue'
import TagsList from './tagsList.vue'
import Form from './addForm.vue'
import draggable from 'vuedraggable'
import {
  getTaskSerialNumber,
  saveTask,
  findLabelList,
  findAllFrom,
  flowRole,
  getEndDate,
  getWorkTime
} from '../../utils/api/task'
import { getFormDetail } from '../../utils/api/form'
import { myProList } from '../../utils/api/project'
import { myFlowList, flowDetail } from '../../utils/api/process' // findGropList,
import { findUserIds } from '../../utils/api/user.js' // , addDingFile
import { delChange, editChange } from '../../utils/tag.js'
import Vue from 'vue'
import { wxConfig } from '../../utils/wxConfig'
import choose from 'dingtalk-jsapi/api/biz/contact/choose' // PC 通讯录选人
export default {
  components: {
    Dialogs,
    Describe,
    TagsList,
    draggable,
    Form
  },
  data() {
    return {
      channel: JSON.parse(sessionStorage.getItem('loginUserData')).channel,
      corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId,
      tryOutType: JSON.parse(sessionStorage.getItem('loginUserData')).tryOutType,
      proId: '',
      versionId: '',
      // 创建任务
      dialogCreat: {},
      // 描述
      describes: {
        describe: '',
        maxlength_show: true,
        descList: [],
        objectType: '1',
        objectId: '',
        taskId: '',
        proId: this.$route.query.id,
        versionId: '',
        type: '0',
        appendType: '2',
        editTaskChange: this.editTaskChange,
        nullFlage: '0',
        createFlage: '0'
      },
      responseUsers_popover: false,
      confirmUsers_popover: false,
      // 开始日期范围
      pickerOptions: {
        disabledDate: (time) => {
          // 如果有计划结束时间，开始时间不能大于结束时间
          if (this.dialogCreat.planEndDate) {
            return time.getTime() > Date.parse(this.dialogCreat.planEndDate)
          }
          return false
        }
      },
      // 结束日期范围
      pickerOptions1: {
        disabledDate: (time) => {
          // 结束时间不能小于开始时间
          if (this.dialogCreat.planStartDate) {
            return time.getTime() < Date.parse(this.dialogCreat.planStartDate)
          }
          return false
        }
      },
      // 流程类型
      options: [],
      // 所属项目
      proType: [],
      // 标签列表
      tagList: [],
      tagsObject: {
        checkboxGroup: [],
        fun: this.checkboxGroupChange
      },
      formList: [],
      formJson: [],
      formData: [],
      roleList: [],
      formDetailValue: {}
    }
  },
  mounted() {
    // this.formDetail()
    this.dialogCreat.formId = this.formList[0]?.id
    if (this.channel === 'wechat') {
      wxConfig()
    }
  },
  methods: {
    // 钉钉通讯录选人组件
    contactChoose(userids, type) {
      // alert('userids ' + JSON.stringify(userids))
      var that = this
      choose({
        multiple: true, // 是否多选：true多选 false单选； 默认true
        users: userids, // 默认选中的用户列表，员工userid；成功回调中应包含该信息
        corpId: JSON.parse(sessionStorage.getItem('loginUserData')).corpId, // 企业id
        max: 100, // 人数限制，当multiple为true才生效，可选范围1-1500
        // emplId 员工ID
        onSuccess: function(res) {
          if (res.length > 0) {
            var date = {
              users: res
            }
            // alert('数据 ' + JSON.stringify(date))
            findUserIds(date)
              .then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.setupTaskFollow(res1.result.userList, type)
                } else {
                  this.$message.warning(
                    res1.result.unAuthUserNameList.join(',') + ' 未授权'
                  )
                }
              })
              .catch((error) => {
                console.log('error111', error)
                //  this.$message.error('网络错误，请稍候！')
              })
          }
        },
        onFail: function(err) {
          console.log('err111', err)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        }
      })
        .then((res) => {
          console.log('then______err', res)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        })
        .catch((err) => {
          console.log('catch______err', err)
          // alert('$ANTDD error: ' + JSON.stringify(err))
        })
    },
    // 企微通讯录选人组件
    wechatLogin(userids, type) {
      var that = this
      if (this.tryOutType === '1') {
        Vue.prototype.$wx.invoke('selectPrivilegedContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': 'multi', // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectPrivilegedContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList || []// 已选的成员列表
            const selectedTicketList = res.result.selectedTicket || '' // 已选的成员Ticket列表
            if (selectedUserList.length > 0 || selectedTicketList.length > 0) {
              var date = {
                users: selectedUserList,
                ticket: selectedTicketList,
                type: 'user'
              }
              // alert('数据 ' + JSON.stringify(date))
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.setupTaskFollow(res1.result.userList, type)
                } else {
                  this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
                }
              }).catch((error) => {
                console.log(error)
              //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      } else {
        Vue.prototype.$wx.invoke('selectEnterpriseContact', {
          'fromDepartmentId': -1, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
          'mode': 'multi', // 必填，选择模式，single表示单选，multi表示多选
          'type': ['user'], // 必填，选择限制类型，指定department、user中的一个或者多个
          'selectedDepartmentIds': [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
          'selectedUserIds': userids // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
        }, function(res) {
          if (res.err_msg === 'selectEnterpriseContact:ok') {
            if (typeof res.result === 'string') {
              res.result = JSON.parse(res.result) // 由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
            }
            const selectedUserList = res.result.userList // 已选的成员列表
            if (selectedUserList.length > 0) {
              var date = {
                users: selectedUserList
              }
              // alert('数据 ' + JSON.stringify(date))
              findUserIds(date).then((res1) => {
                if (res1.code === 10000 && res1.result.isAll) {
                  that.setupTaskFollow(res1.result.userList, type)
                } else {
                  this.$message.warning(res1.result.unAuthUserNameList.join(',') + ' 未授权')
                }
              }).catch((error) => {
                console.log(error)
                //  this.$message.error('网络错误，请稍候！')
              })
            }
          }
        })
      }
    },
    // 编辑负责人
    setupTaskFollow(res, type) {
      // alert('数据 ' + JSON.stringify(res), type)
      if (type === 1) {
        this.dialogCreat.responseUsers = res
      } else if (type === 2) {
        this.dialogCreat.confirmUsers = res
      } else if (type === 3) {
        this.dialogCreat.followUserList = res
        if (this.formDetailValue) {
          const originalData = res

          const newUserList = originalData.map(item => ({
            name: item.name,
            id: item.id,
            avatar: item.avatar,
            userType: '1', // 固定设置userType为1
            userid: item.userid
          }))
          this.formDetailValue.followUsers = newUserList
          this.dialogCreat.followUserList = res
        }
      } else {
        this.roleList.map((item) => {
          if (type === item.id) {
            item.userList = res
          }
        })
      }
    },
    // 添加负责人
    contactCh(principalUsers, type) {
      if (!principalUsers) {
        principalUsers = []
      }
      var userids = []
      principalUsers.map((item) => {
        userids.push(item.userid)
      })
      if (this.channel === 'ding') {
        this.contactChoose(userids, type)
      } else if (this.channel === 'wechat') {
        this.wechatLogin(userids, type)
      }
    },
    // 删除负责人
    delUsers(principalUsers, index, type) {
      principalUsers.splice(index, 1)
      this.setupTaskFollow(principalUsers, type, this.dialogCreat.id)
    },
    addtask(result) {
      this.describes.descList = result
    },
    // 标签透明度
    convertHex(hex, opacity) {
      hex = hex?.replace('#', '')
      var r = parseInt(hex?.substring(0, 2), 16)
      var g = parseInt(hex?.substring(2, 4), 16)
      var b = parseInt(hex?.substring(4, 6), 16)
      var result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
      return result
    },
    // 编辑任务标签
    checkboxGroupChange() {
      this.dialogCreat.labelList = editChange(
        this.tagList,
        this.tagsObject.checkboxGroup
      )
    },
    // 删除任务标签
    delTagsChange(tag) {
      this.tagsObject.checkboxGroup.splice(
        delChange(tag, this.tagsObject.checkboxGroup),
        1
      )
      this.checkboxGroupChange()
    },
    // 任务标签列表
    getTabsList() {
      this.tagsObject.checkboxGroup = []
      findLabelList()
        .then((data) => {
          if (data.code === 10000) {
            this.tagList = data.result
            this.dialogCreat.labelList.map((tag) => {
              this.tagsObject.checkboxGroup.unshift(tag.id)
            })
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
    },
    // 流程类型
    getChoiceList() {
      var date = {
        flowName: ''
      }
      myFlowList(date)
        .then((data) => {
          if (data.code === 10000) {
            this.options = data.result
            this.roleList = []
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
    },
    // 所属项目
    getChoiceProList() {
      myProList({})
        .then((data) => {
          if (data.code === 10000) {
            this.proType = data.result
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
    },
    // 流程橘色
    processDeta() {
      this.formJson = []
      var date1 = {
        id: this.dialogCreat.flowId
      }
      flowDetail(date1).then((data1) => {
        if (data1.code === 10000) {
          this.formDetailValue = data1.result
          this.$nextTick(() => {
            const originalArray = data1.result.followUsers
            const filteredArray = originalArray.filter(item => item.userType === '1')
            this.dialogCreat.followUserList = filteredArray
          })
          this.dialogCreat.labelList = data1.result.followLabels
          this.describes.describe = data1.result.remark
          this.describes.descList = data1.result.fileList
          if (data1.result.formId) {
            this.dialogCreat.formId = data1.result.formId
            var formJson = data1.result.formFields || []
            formJson.map((item, index) => {
              item.strArray = item.strArray || []
              this.formJson.push(item)
              if (item.formField.type === '2') {
                item.describes = {
                  describe: item.content || '',
                  maxlength_show: true,
                  descList: item.files || [],
                  editTaskChange: this.editTaskChange2,
                  objectType: '1',
                  proId: '',
                  type: '15',
                  appendType: '2',
                  index
                }
              }
              if (item.formField.type === '3') {
                item.files = item.files || []
              }
              if (item.formField.type === '10' || item.formField.type === '11') {
                item.users = item.users || []
              }
              if (item.formField.type === '7' || item.formField.type === '9') {
                item.fieldValue = item.strArray || []
                this.formData.push({
                  fieldId: item.formField.id,
                  fieldName: item.formField.fieldName,
                  nullFlage: item.formField.nullFlage,
                  createFlage: item.formField.createFlage,
                  type: item.formField.type,
                  fieldValue: item.fieldValue
                })
              } else if (item.formField.type) {
                item.fieldValue = item.fieldValue || ''
                this.formData.push({
                  fieldId: item.formField.id,
                  fieldName: item.formField.fieldName,
                  nullFlage: item.formField.nullFlage,
                  createFlage: item.formField.createFlage,
                  type: item.formField.type,
                  fieldValue: item.fieldValue
                })
              } else if (!item.formField.type && item.formField.fieldName === '描述') {
                this.describes.nullFlage = item.formField.nullFlage
                this.describes.createFlage = item.formField.createFlage
              } else if (!item.formField.type && item.formField.fieldName === '标签') {
                this.dialogCreat.nullFlage = item.formField.nullFlage
                this.dialogCreat.createFlage = item.formField.createFlage
              }
            })
            // this.formJson = formJson
            if (this.formDetailValue.formId) {
              this.addForm(this.formJson, this.dialogCreat, this.describes, 'process')
            } else {
              this.addForm(this.formJson, this.dialogCreat, this.describes, '')
            }
          } else {
            this.dialogCreat.formId = '0'
          }
          // 获取当前日期和时间
          var now = new Date()

          // 获取年、月、日、时、分、秒
          var year = now.getFullYear()
          var month = ('0' + (now.getMonth() + 1)).slice(-2) // getMonth返回的月份是从0开始的，所以需要+1
          var day = ('0' + now.getDate()).slice(-2)
          var hours = ('0' + now.getHours()).slice(-2)
          var minutes = ('0' + now.getMinutes()).slice(-2)
          var seconds = ('0' + now.getSeconds()).slice(-2)

          // 拼接成指定格式的字符串
          var formattedTime = year + '/' + month + '/' + day + ' ' + hours + ':' + minutes + ':' + seconds

          this.getEndDate(formattedTime, data1.result.planWorkTime, data1.result.workTimeType)
          var date = {
            flowId: this.dialogCreat.flowId
          }
          flowRole(date).then((data) => {
            if (data.code === 10000) {
              this.roleList = data.result
            }
          })
        }
      })
    },
    // 获取流程模板时间
    getEndDate(formattedTime, planWorkTime, workTimeType) {
      var date = {
        planStartDate: formattedTime,
        planWorkTime: planWorkTime,
        workTimeType: workTimeType
      }
      getEndDate(date).then((data) => {
        if (data.code === 10000) {
          this.dialogCreat.planEndDate = data.result.planEndDate.replace(/-/g, '/')
          this.dialogCreat.planStartDate = data.result.planStartDate.replace(/-/g, '/')
          this.dialogCreat.planWorkTime = data.result.planWorkTime
        } else {
          this.$message.warning(data.info)
        }
      }).catch((error) => {
        console.log(error)
        //  this.$message.error('网络错误，请稍候！')
      })
    },
    // 表单类型列表
    getFromList() {
      var date = {}
      findAllFrom(date)
        .then((data) => {
          if (data.code === 10000) {
            this.formList = data.result
            this.dialogCreat.formId = this.formList[0]?.id
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
    },
    // 表单字段列表
    formDetail() {
      var date = {
        formId: this.dialogCreat.formId
      }
      getFormDetail(date)
        .then((data) => {
          if (data.code === 10000) {
            var formJson = data.result
            formJson.map((item, index) => {
              if (item.type === '2') {
                item.describes = {
                  describe: '',
                  maxlength_show: true,
                  descList: [],
                  editTaskChange: this.editTaskChange1,
                  objectType: '1',
                  proId: '',
                  type: '15',
                  appendType: '2',
                  index
                }
              }
              if (item.type === '3') {
                item.fileList = []
              }
              if (item.type === '10' || item.type === '11') {
                item.userList = []
              }
              if (item.type === '7' || item.type === '9') {
                item.fieldValue = []
                this.formData.push({
                  fieldId: item.id,
                  fieldName: item.fieldName,
                  nullFlage: item.nullFlage,
                  createFlage: item.createFlage,
                  type: item.type,
                  fieldValue: item.fieldValue
                })
              } else if (item.type) {
                item.fieldValue = ''
                this.formData.push({
                  fieldId: item.id,
                  fieldName: item.fieldName,
                  nullFlage: item.nullFlage,
                  createFlage: item.createFlage,
                  type: item.type,
                  fieldValue: item.fieldValue
                })
              } else if (!item.type && item.fieldName === '描述') {
                this.describes.nullFlage = item.nullFlage
                this.describes.createFlage = item.createFlage
              } else if (!item.type && item.fieldName === '标签') {
                this.dialogCreat.nullFlage = item.nullFlage
                this.dialogCreat.createFlage = item.createFlage
              }
            })
            this.formJson = formJson
            this.addForm(this.formJson, this.dialogCreat, this.describes, '')
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
    },
    // 计划开始时间
    focusStartChange() {
      const that = this
      this.pickerOptions = {
        disabledDate(time) {
          // 若结束时间存在，开始时间不能晚于结束时间
          if (that.dialogCreat.planEndDate) {
            return time.getTime() > Date.parse(that.dialogCreat.planEndDate)
          }
          return false
        }
      }
    },
    // 计划结束时间
    focusEndChange() {
      const that = this
      this.pickerOptions1 = {
        disabledDate(time) {
          // 若开始时间存在，结束时间不能早于开始时间
          if (that.dialogCreat.planStartDate) {
            const startDate = new Date(that.dialogCreat.planStartDate)
            // 转换为当天 00:00:00
            startDate.setHours(0, 0, 0, 0)
            return time.getTime() < startDate.getTime()
          }
          return false
        }
      }
    },
    // 计划时间失去焦点
    blurChange() {
      // if (
      //   this.dialogCreat.planStartDate !== '' &&
      //   this.dialogCreat.planEndDate !== ''
      // ) {
      //   var timer = this.getDifferTime(
      //     this.dialogCreat.planStartDate,
      //     this.dialogCreat.planEndDate
      //   )
      //   this.dialogCreat.planWorkTime = Math.ceil(timer)
      // }
      var date = {
        startDate: this.dialogCreat.planStartDate,
        endDate: this.dialogCreat.planEndDate,
        workTimeType: this.dialogCreat.workTimeType // 工作日0否  1是
      }
      getWorkTime(date).then((data) => {
        if (data.code === 10000) {
          this.dialogCreat.planWorkTime = data.result.planWorkTime
        }
      })
    },
    // 计算工期时间
    getDifferTime(startDate, endDate) {
      const startTime = new Date(
        Date.parse(startDate.replace(/-/g, '/'))
      ).getTime()
      const endTime = new Date(Date.parse(endDate.replace(/-/g, '/'))).getTime()
      const dates = Math.ceil(
        Math.abs(startTime - endTime) / (1000 * 60 * 60 * 24)
      )
      return dates
    },
    // 表单数据
    addForm(date, creat, describes, type) {
      this.describes.describe = describes.describe
      this.describes.descList = describes.descList
      this.dialogCreat.labelList = creat.labelList
      var arr = []
      date.map((item) => {
        if (item.formFiel || type === 'process') {
          if (item.formField.type === '2') {
            var deacData = {
              content: item.describes.describe,
              fileIds: item.describes.descList
            }
            var fileIds = []
            item.describes.descList.map((desc) => {
              fileIds.push(desc.id)
            })
            deacData.fileIds = fileIds.toString()
            arr.push({
              fieldId: item.formField.id,
              fieldName: item.formField.fieldName,
              nullFlage: item.formField.nullFlage,
              createFlage: item.formField.createFlage,
              type: item.formField.type,
              fieldValue: JSON.stringify(deacData)
            })
          } else if (item.formField.type === '3') {
            var fileList = []
            item.files.map((user) => {
              fileList.push(user.id)
            })
            arr.push({
              fieldId: item.formField.id,
              fieldName: item.formField.fieldName,
              nullFlage: item.formField.nullFlage,
              createFlage: item.formField.createFlage,
              type: item.formField.type,
              fieldValue: fileList.toString()
            })
          } else if (item.formField.type === '10' || item.formField.type === '11') {
            var fieldValue = []
            item.users.map((user) => {
              fieldValue.push(user.id)
            })
            arr.push({
              fieldId: item.formField.id,
              fieldName: item.formField.fieldName,
              nullFlage: item.formField.nullFlage,
              createFlage: item.formField.createFlage,
              type: item.formField.type,
              fieldValue: fieldValue.toString()
            })
          } else if (item.formField.type) {
            arr.push({
              fieldId: item.formField.id,
              fieldName: item.formField.fieldName,
              nullFlage: item.formField.nullFlage,
              createFlage: item.formField.createFlage,
              type: item.formField.type,
              fieldValue: item.fieldValue ? (item.fieldValue).toString() : ''
            })
          }
        } else {
          if (item.type === '2') {
            var deacData1 = {
              content: item.describes.describe,
              fileIds: ''
            }
            var fileIds1 = []
            item.describes.descList.map((desc) => {
              fileIds1.push(desc.id)
            })
            deacData1.fileIds = fileIds1.toString()
            arr.push({
              fieldId: item.id,
              fieldName: item.fieldName,
              nullFlage: item.nullFlage,
              createFlage: item.createFlage,
              type: item.type,
              fieldValue: JSON.stringify(deacData1)
            })
          } else if (item.type === '3') {
            var fileList1 = []
            item.fileList.map((user) => {
              fileList1.push(user.id)
            })
            arr.push({
              fieldId: item.id,
              fieldName: item.fieldName,
              nullFlage: item.nullFlage,
              createFlage: item.createFlage,
              type: item.type,
              fieldValue: fileList1.toString()
            })
          } else if (item.type === '10' || item.type === '11') {
            var fieldValue1 = []
            item.userList.map((user) => {
              fieldValue1.push(user.id)
            })
            arr.push({
              fieldId: item.id,
              fieldName: item.fieldName,
              nullFlage: item.nullFlage,
              createFlage: item.createFlage,
              type: item.type,
              fieldValue: fieldValue1.toString()
            })
          } else if (item.type) {
            arr.push({
              fieldId: item.id,
              fieldName: item.fieldName,
              nullFlage: item.nullFlage,
              createFlage: item.createFlage,
              type: item.type,
              fieldValue: item.fieldValue ? (item.fieldValue).toString() : ''
            })
          }
        }
      })
      this.formData = arr
    },
    // 点击创建按钮
    submitDialogCre() {
      if (this.dialogCreat.taskname === '') {
        this.$message.warning('任务名称不能为空！')
        return
      } else if (this.dialogCreat.taskNumber === '') {
        this.$message.warning('任务编号不能为空！')
        return
      } else if (this.dialogCreat.taskType === '1' && this.dialogCreat.flowId === '') {
        this.$message.warning('工作流程不能为空！')
        return
      }
      // 检查角色列表
      if (this.roleList && this.roleList.length > 0) {
        for (const role of this.roleList) {
          if (role.mustFlag === '1' && role.userList.length === 0) {
            this.$message.warning(`角色${role.roleName} 人员不能为空！`)
            return
          }
        }
      }
      var labelIds = []
      if (!this.dialogCreat.labelList) {
        this.dialogCreat.labelList = []
      }
      this.dialogCreat.labelList.map((item) => {
        labelIds.push(item.id)
      })
      var fileList = []
      if (!this.describes.descList) {
        this.describes.descList = []
      }
      this.describes.descList.map((item) => {
        fileList.push(item.id)
      })
      if (this.describes.createFlage === '1' && this.describes.describe === '') {
        this.$message.warning('描述不能为空！')
        return
      }
      if (this.dialogCreat.createFlage === '1' && labelIds.length === 0) {
        this.$message.warning('标签不能为空！')
        return
      }
      var value = this.formData.some((item) => {
        if (item.type && item.type === '2' && item.createFlage === '1' && (JSON.parse(item.fieldValue).content === '' && JSON.parse(item.fieldValue).fileIds === '')) {
          this.$message.warning(item.fieldName + '不能为空！')
          return true
        } else if (item.type && item.type !== '2' && item.createFlage === '1' && item.fieldValue === '') {
          this.$message.warning(item.fieldName + '不能为空！')
          return true
        }
      })
      if (value) {
        return
      }
      var responseUsers = []
      if (!this.dialogCreat.responseUsers) {
        this.dialogCreat.responseUsers = []
      }
      this.dialogCreat.responseUsers.map((item) => {
        responseUsers.push(item.id)
      })
      var confirmUsers = []
      if (!this.dialogCreat.confirmUsers) {
        this.dialogCreat.confirmUsers = []
      }
      this.dialogCreat.confirmUsers.map((item) => {
        confirmUsers.push(item.id)
      })
      var followUserList = []
      if (!this.dialogCreat.followUserList) {
        this.dialogCreat.followUserList = []
      }
      this.dialogCreat.followUserList.map((item) => {
        followUserList.push(item.id)
      })
      // 角色
      const data = this.roleList

      const resultMap = {}

      if (data && data.length > 0) {
        data.forEach(item => {
          const roleName = item.id

          if (!resultMap[roleName]) {
            resultMap[roleName] = []
          }

          // 添加userList中的id到结果中
          item.userList.forEach(user => {
            resultMap[roleName].push(user.id)
          })
        })

        // 转换数组为逗号分隔的字符串
        for (const key in resultMap) {
          resultMap[key] = resultMap[key].join(',')
        }
      }
      // if (this.describes.nullFlage === '1' && this.describes.describe === '' && fileList.length === 0) {
      //   this.$message.warning('描述不能为空！')
      //   return
      // }
      // if (this.dialogCreat.nullFlage === '1' && labelIds.length === 0) {
      //   this.$message.warning('标签不能为空！')
      //   return
      // }
      this.dialogCreat.operatorList[1].disabled = true
      var date = {
        proTypeId: '0',
        parentId: this.dialogCreat.parentId,
        proId: this.dialogCreat.proId,
        flowId: this.dialogCreat.flowId,
        taskType: this.dialogCreat.taskType,
        taskNumber: this.dialogCreat.taskNumber,
        taskname: this.dialogCreat.taskname,
        responseUser: responseUsers.join(','),
        responseType: this.dialogCreat.responseType,
        planStartDate: this.dialogCreat.planStartDate,
        planEndDate: this.dialogCreat.planEndDate,
        planWorkTime: this.dialogCreat.planWorkTime,
        confirmUser: confirmUsers.join(','),
        confirmType: this.dialogCreat.confirmType,
        taskRemark: this.describes.describe,
        followUserIds: followUserList,
        labelIds: labelIds,
        fileIds: fileList,
        formId: this.dialogCreat.formId || 0,
        formFields: this.formData,
        depositDate: this.dialogCreat.depositDate,
        drawingDate: this.dialogCreat.drawingDate,
        prodPlanEndDate: this.dialogCreat.prodPlanEndDate,
        roleUsers: resultMap,
        versionId: this.dialogCreat.versionId,
        workTimeType: this.dialogCreat.workTimeType
      }
      saveTask(date)
        .then((data) => {
          this.dialogCreat.operatorList[1].disabled = false
          if (data.code === 10000) {
            // this.dialogCreat.operatorList[1].loading = false
            this.dialogCreat.operatorList[1].disabled = true
            this.dialogCreat.addDounced = false
            this.$message.success('创建任务成功！')
            if (!this.dialogCreat.parentId) {
              this.$parent.$parent.findAll()
            }
            this.$emit('addTaskChange')
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
    },
    // 取消创建
    cancelDialog() {
      this.dialogCreat.addDounced = false
    },
    // 选择工期类型
    selectWorkType(index) {
      if (index === '0') {
        this.dialogCreat.workTimeType = '0'
      } else if (index === '1') {
        this.dialogCreat.workTimeType = '1'
      }
      var date = {
        startDate: this.dialogCreat.planStartDate,
        endDate: this.dialogCreat.planEndDate,
        workTimeType: this.dialogCreat.workTimeType // 工作日0否  1是
      }
      getWorkTime(date).then((data) => {
        if (data.code === 10000) {
          this.dialogCreat.planWorkTime = data.result.planWorkTime
        }
      })
    },
    // 打开创建任务
    openDialog(proId, versionId) {
      this.proId = proId
      this.versionId = versionId
      this.dialogCreat = {
        addDounced: true, // 显示新增
        title: '创建任务',
        width: '800px',
        slotName: 'desc',
        id: '',
        taskname: '', // 任务名称
        taskNumber: '', // 任务编号
        proId: proId || '', // 所属项目
        taskType: '0', // 任务类型
        flowId: '', // 流程类型
        formId: '', // 表单类型
        planStartDate: '', // 计划开始时间
        planEndDate: '', // 计划结束时间
        planWorkTime: '1', // 工期
        taskRemark: '', // 描述
        responseUsers: [], // 负责人
        confirmType: '0', // 负责人签名方式
        confirmUsers: [], // 确认人
        responseType: '0', // 确认人签名方式
        followUserList: [], // 关注人
        nullFlage: '0', // 标签必填 1/0
        labelList: [], // 标签
        fileList: [],
        depositDate: '', // 订金日期
        drawingDate: '', // 图纸确认日期
        prodPlanEndDate: '', // 预计完成日期
        versionId: versionId, // 项目分组id
        defaultime: '',
        workTimeType: '0', // 工期类型
        // 操作按钮
        operatorList: [
          { label: '取消', type: '', loading: false, fun: this.cancelDialog },
          {
            label: '创建',
            type: 'primary',
            loading: false,
            fun: this.submitDialogCre,
            disabled: false
          }
        ]
      }
      this.describes.describe = ''
      this.describes.descList = []
      this.describes.nullFlage = '0'
      this.formData = []
      getTaskSerialNumber({})
        .then((data) => {
          if (data.code === 10000) {
            // this.dialogCreat.taskNumber = data.result
            this.dialogCreat.taskNumber = data.result.taskNumber
            this.dialogCreat.defaultime = data.result
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error)
          //  this.$message.error('网络错误，请稍候！')
        })
      this.getTabsList()
      this.getChoiceProList()
      this.getFromList()
      // this.dialogCreat.formId = this.formList[0].id
    },
    // 打开创建子任务
    openDialogChild(parentId, proId, versionId) {
      this.openDialog(proId, versionId)
      this.dialogCreat.addDounced = true // 显示新增
      this.dialogCreat.title = '创建子任务'
      this.dialogCreat.proId = proId
      this.dialogCreat.parentId = parentId // 父级id
      this.dialogCreat.versionId = versionId
      this.describes.describe = ''
      this.describes.descList = []
      this.describes.nullFlage = '0'
      this.formData = []
      getTaskSerialNumber({})
        .then((data) => {
          if (data.code === 10000) {
            this.dialogCreat.taskNumber = data.result.taskNumber
            // this.dialogCreat.taskNumber = data.result
            this.dialogCreat.defaultime = data.result
          } else {
            this.$message.warning(data.info)
          }
        })
        .catch((error) => {
          console.log(error, '')
          //  this.$message.error('网络错误，请稍候！')
        })
      this.getTabsList()
      this.getChoiceProList()
      this.getFromList()
      this.dialogCreat.formId = this.formList[0].id
    },
    // 关闭前的回调(弹框)
    beforeClose(val) {
      this.dialogCreat.addDounced = val.addDounced
    },
    editTaskChange(key, value) {
    },
    // 富文本失去焦点
    editTaskChange1(key, value, index) {
      this.formJson[index].describes.describe = value
      this.addForm(this.formJson, this.dialogCreat, this.describes, '')
    },
    editTaskChange2(key, value, index) {
      this.formJson[index].describes.describe = value
      this.addForm(this.formJson, this.dialogCreat, this.describes, 'process')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index.scss';
.drawer_content {
  // width: 100%;
  width: calc(100% - 30px);
  height: 676px;
  padding: 0 14px;
  overflow-x: auto;
}
::v-deep .el-select {
  width: 100% !important;
}
.progress_icon {
  font-size: 14px;
  cursor: pointer;
}
.info {
  width: 100% !important;
}
.info_subject {
  display: flex;
  align-items: baseline;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_6;
  line-height: 22px;
  border-bottom: 1px solid #e9e9ea;
  margin-bottom: 25px;
}
.info_subject::before {
  content: '*';
  color: #ff4d42;
}
.info_subject ::v-deep .el-textarea__inner {
  padding: 5px 10px;
  border: none;
}
.select_type {
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_6;
  margin: 20px;
}
.select_type_radio {
  margin: 24px 19px;
}
.select__type_personnel {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.select__type_personnel_clear {
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_main;
  cursor: pointer;
}
.users_personnel1 {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-left: 9px;
  margin-top: 20px;
}
.user_personnel1 {
  position: relative;
  display: flex;
  align-items: center;
  // width: 85px;
  // padding: 4px 0;
  border-radius: 4px;
}
.user_personnel1:hover {
  // width: 65px;
  // padding: 4px 10px;
  background: #f6f6f6;
}
.user_personnel1:hover .del_icon {
  display: block;
}
.info_personnel1 {
  // width: 65px;
  font-size: $font_12;
  font-family: $font_family;
  font-weight: 400;
  color: $color_4;
  padding: 4px 15px 4px 10px;
  line-height: 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.info_personnel_surname1 {
  width: 25px;
  height: 25px;
  font-size: $font_14;
  font-family: $font_family;
  font-weight: 400;
  color: $color_white;
  line-height: 25px;
  text-align: center;
  color: $color_white;
  background: $color_main;
  border-radius: 50%;
  margin-right: 8px;
}
.add_icon {
  font-size: $font_20;
  color: $color_9;
  margin: 0 10px;
  cursor: pointer;
}
.add_icon:hover {
  color: $color_main;
}
.del_icon {
  font-size: $font_16;
  color: $color_9;
  line-height: 16px;
  position: absolute;
  top: -8px !important;
  right: -6px !important;
  display: none;
  cursor: pointer;
}
.del_icon:hover {
  color: $color_main;
}
.add_text {
  font-size: 13px;
  font-family: $font_family;
  font-weight: 400;
  color: #a8a8a8;
  cursor: pointer;
}
.add_text:hover {
  color: $color_main;
}
.info_personnel {
  padding: 6.5px 10px !important;
}
// 创建任务
::v-deep .del__icon {
  font-size: 14px;
  color: #9c9c9c;
  cursor: pointer;
  display: block;
}
::v-deep .el-input__suffix {
  display: none;
}
::v-deep .el-input__inner {
  height: 36px;
  line-height: 36px;
}
::v-deep .el-input__icon {
  line-height: 36px;
}
.form_fieldName {
  width: 69px;
    color: $color_8;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
::v-deep .el-input--suffix .el-input__inner{
  padding-right: 20px !important;
}
.time_input {
  ::v-deep .el-input__inner {
    padding: 0 10px !important;
  }
}
</style>
